import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogContent,
  Backdrop,
  MenuItem,
  Select,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import imguploadicon from "../../assets/images/svg/image-upload-icon.svg";
import { enqueueSnackbar } from "notistack";
import SelectInput from "@mui/material/Select/SelectInput";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { $crud } from "../../utils/CrudFactory";

import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backdropFilter: "blur(2px)",
  },
  dialogPaper: {
    borderRadius: "12px",
    border: "1px solid #000",
  },
  textFieldRoot: {
    "& .MuiInputLabel-root": {
      color: "#8D8D8E !important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(103, 60, 142, 1)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(103, 60, 142, 1)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(103, 60, 142, 1)",
      },
    },
  },
}));

const EditDriverModal = ({ onClose, open, driver, setDriver }) => {
  const classes = useStyles();

  const handleSubmit = async (e) => {
    const formdata = new FormData(e.target);
    const data = Object.fromEntries(formdata);
    data.enroldate = new Date(data.enroldate || Date.now()).toISOString();
    try {
      const res = await $crud.put("admin/tax-details-driver", {
        taxID: data.taxid,
        taxName: data.taxname,
        enrollmentforTaxDate: data.enroldate,
        isEnrolledForSalesTax: data.saletax,
        _id: driver._id,
      });
      setDriver({
        ...res.data.updatedDriver,
        isEnrolledforsalesTax: res.data.updatedDriver.isEnrolledforsalesTax
          ? "Yes"
          : "No",
      });
      onClose(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={open} />
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        maxWidth="lg"
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent
          sx={{
            padding: "25px",
            backgroundColor: "#ffffff",
            height: "422px",
            minWidth: "706px",
            position: "relative",
          }}
        >
          <IconButton
            title="Click To Close"
            onClick={() => onClose(false)}
            sx={{ position: "absolute", top: "18px", right: "25px" }}
          >
            <HighlightOffIcon
              sx={{
                width: "18px",
                height: "18px",
                color: "black",
              }}
            />
          </IconButton>
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={"10px"}
            mt={"28px"}
          >
            <Typography fontSize={"18px"} fontWeight={600} color={"#000000"}>
              Driver's Details
            </Typography>
            <Typography fontSize={"14px"}>{driver.driverID}</Typography>
          </Box>
          <form
            style={{ marginTop: "15px" }}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(e);
            }}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={"17px"}
            >
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <label
                  style={{ fontWeight: 500, fontSize: "14px", color: "black" }}
                >
                  Enrolled for Sales Tax
                </label>
                <Select
                  title="Select 'Yes' or 'No'"
                  name="saletax"
                  displayEmpty
                  required
                  defaultValue={
                    driver.isEnrolledforsalesTax === "Yes" ? "true" : "false"
                  }
                  sx={{
                    height: "52px",
                    borderRadius: "12px",
                    color: "#1A1C1E8C",
                    fontWeight: 500,
                    width: "302px",
                    boxShadow: "0px 1px 2px 0px #E4E5E73D",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #7E7E7E !important",
                    },
                  }}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
              </Box>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <label
                  style={{ fontWeight: 500, fontSize: "14px", color: "black" }}
                >
                  Enrollment date
                </label>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="enroldate"
                    format="DD MMM YYYY"
                    defaultValue={dayjs(driver.enrollmentforTaxDate)}
                    slotProps={{
                      textField: {
                        placeholder: "Select The Date",
                        sx: {
                          height: "52px",
                          width: "302px",
                          borderRadius: "12px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "1px solid #7E7E7E !important", // ✅ custom border
                              borderRadius: "12px",
                            },
                            "&:hover fieldset": {
                              borderColor: "#7E7E7E",
                            },
                          },
                          "& input": {
                            fontWeight: 500,
                            color: "#000000",
                            padding: "14px",
                            boxShadow: "0px 1px 2px 0px #E4E5E73D",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={"17px"}
              marginTop={"25px"}
            >
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <label
                  style={{ fontWeight: 500, fontSize: "14px", color: "black" }}
                >
                  Tax Name
                </label>
                <input
                  type="text"
                  placeholder="HST"
                  required
                  defaultValue={driver.taxName}
                  name="taxname"
                  title="Enter Tax Name"
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Please fill this field")
                  }
                  onInput={(e) => e.target.setCustomValidity("")}
                  style={{
                    padding: "14px",
                    outline: "none",
                    height: "52px",
                    border: "1px solid #7E7E7E",
                    borderRadius: "12px",
                    color: "#000000",
                    fontWeight: 500,
                    width: "302px",
                    boxShadow: "0px 1px 2px 0px #E4E5E73D",
                  }}
                />
              </Box>
              <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <label
                  style={{ fontWeight: 500, fontSize: "14px", color: "black" }}
                >
                  Tax ID
                </label>
                <input
                  type="text"
                  name="taxid"
                  title="Enter Tax Id"
                  placeholder="731807012RT0001"
                  defaultValue={driver.taxID}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Please fill this field")
                  }
                  onInput={(e) => e.target.setCustomValidity("")}
                  style={{
                    padding: "14px",
                    outline: "none",
                    height: "52px",
                    border: "1px solid #7E7E7E",
                    borderRadius: "12px",
                    color: "#000000",
                    fontWeight: 500,
                    width: "302px",
                    boxShadow: "0px 1px 2px 0px #E4E5E73D",
                  }}
                />
              </Box>
            </Box>
            <Box
              width={"100%"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"end"}
              sx={{ marginTop: "26px" }}
            >
              <Button
                title="Click To Update"
                type="submit"
                sx={{
                  width: "200px",
                  height: "42px",
                  backgroundColor: "#673C8E !important",
                  color: "white",
                  borderRadius: "12px",
                }}
              >
                Update
              </Button>
            </Box>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EditDriverModal;
